import { CurrencyPipe } from '@angular/common';
import { Column, GridRow } from '@shared';

class OverrideItem {
  id: string;
  status?: string;

  type = 'pricing';

  @Column({
    field: 'restaurantName',
    title: 'Restaurant',
    order: 0.1,
    width: 80,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: false,
    align: 'left',
  })
  restaurantName: string;

  @Column({
    field: 'tierName',
    title: 'Tier',
    order: 0,
    width: 170,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  tierName: string;

  componentId: number;
  @Column({
    field: 'comboName',
    title: 'Combo',
    order: 1,
    width: 180,
    type: 'string',
    fixed: true,
    visibleInQuickView: true,
    align: 'left',
  })
  comboName: string;
  comboId: string;
  restaurantId: number;

  @Column({
    field: 'componentType',
    title: 'Component Type',
    order: 1.5,
    width: 70,
    type: 'string',
    fixed: true,
    visibleInQuickView: true,
    align: 'left',
  })
  componentType: string;
  componentTypeId: string;
  componentGroupId: string | null;
  componentPrice: number;

  @Column({
    field: 'overridePrice',
    title: 'Custom Amount',
    order: 3,
    width: 80,
    pipeToken: CurrencyPipe,
    type: 'number',
    fixed: true,
    visibleInQuickView: true,
  })
  overridePrice?: number;

  @Column({
    field: 'newOverridePrice',
    title: 'New Custom Amount',
    order: 3,
    width: 80,
    pipeToken: CurrencyPipe,
    type: 'number',
    fixed: true,
    editable: true,
    visibleInQuickView: true,
  })
  newOverridePrice?: number | null;

  @Column({
    field: 'overrideDeliveryPrice',
    title: 'Custom Delivery Amount',
    order: 4,
    width: 80,
    pipeToken: CurrencyPipe,
    type: 'number',
    fixed: true,
    visibleInQuickView: true,
  })
  overrideDeliveryPrice?: number;

  @Column({
    field: 'newOverrideDeliveryPrice',
    title: 'New Custom Delivery Amount',
    order: 5,
    width: 80,
    pipeToken: CurrencyPipe,
    type: 'number',
    fixed: true,
    editable: true,
    visibleInQuickView: true,
  })
  newOverrideDeliveryPrice?: number | null;

  isOverridePrice: boolean;

  @Column({
    field: 'newIsOverridePrice',
    title: 'Override',
    order: 1.6,
    width: 70,
    type: 'boolean',
    fixed: true,
    editable: true,
    visibleInQuickView: true,
  })
  newIsOverridePrice?: boolean | null;

  @Column({
    field: 'componentName',
    title: 'Product',
    order: 0.2,
    width: 100,
    type: 'string',
    visibleInQuickView: true,
    visibleInDetailsView: false,
    align: 'left',
  })
  componentName: string;

  componentParId?: number;
  comboParId?: number;

  scheduledDate: Date | null;

  isSecondaryItem?: boolean;

  isDeliveryAvailable?: boolean;

  constructor(changeset?: Partial<OverrideItem>) {
    this.id = changeset?.id || '';
    this.componentId = changeset?.componentId ?? 0;
    this.comboName = changeset?.comboName ?? '';
    this.comboId = changeset?.comboId ?? '';
    this.overridePrice = changeset?.overridePrice;
    this.newOverridePrice = changeset?.newOverridePrice;
    this.isOverridePrice = changeset?.isOverridePrice ?? false;
    this.newIsOverridePrice =
      changeset?.newIsOverridePrice != null
        ? changeset?.newIsOverridePrice
        : changeset?.isOverridePrice;
    this.overrideDeliveryPrice = changeset?.overrideDeliveryPrice;
    this.newOverrideDeliveryPrice = changeset?.newOverrideDeliveryPrice;
    this.componentName = changeset?.componentName ?? '';
    this.componentType = changeset?.componentType ?? '';
    this.componentTypeId = changeset?.componentTypeId ?? '';
    this.componentGroupId = changeset?.componentGroupId ?? null;
    this.componentPrice = changeset?.componentPrice ?? 0;
    this.restaurantId = changeset?.restaurantId ?? 0;
    this.restaurantName = changeset?.restaurantName ?? '';
    this.tierName = changeset?.tierName ?? '';
    this.scheduledDate = changeset?.scheduledDate ?? null;
    this.status = changeset?.status;
    this.comboParId = changeset?.comboParId;
    this.componentParId = changeset?.componentParId;
    this.isDeliveryAvailable = changeset?.isDeliveryAvailable;
  }
}

export class GridRowOverride extends GridRow(OverrideItem) {}
